<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="inner">
          <h2 class="fz-20 d-flex pb-2 border-bottom mt-5 mb-4">{{ $t('製品情報') }}</h2>
          <div class="table-list mb-5">
            <div class="content">
              <table class="table table-bordered">
                <tbody class="tbody">
                  <tr>
                    <th class="table-active text-left" width="200">{{ $t('品番') }}</th>
                    <td class="text-left" width="280">
                      <template v-if="product.code">
                        {{ product.code }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <th class="table-active text-left" width="200">{{ $t('改訂') }}</th>
                    <td class="text-left" width="280">
                      <template v-if="product.version">
                        {{ product.version }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <th class="table-active text-left" width="200">{{ $t('品名') }}</th>
                    <td class="text-left" width="280">
                      <template v-if="product.name">
                        {{ product.name }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th class="table-active text-left">{{ $t('図番') }}</th>
                    <td class="text-left">
                      <template v-if="product.figureNo">
                        {{ product.figureNo }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <th class="table-active text-left">{{ $t('単位') }}</th>
                    <td class="text-left">
                      <template v-if="product.outputLevel">
                        {{ product.outputLevel }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <th class="table-active text-left">{{ $t('RoHS指令対応') }}</th>
                    <td class="text-left">
                      <template v-if="product.isRoHS">
                        {{ $t('対応') }}
                      </template>
                      <template v-else>
                        {{ $t('非対応') }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th class="table-active text-left">{{ $t('メーカー') }}</th>
                    <td class="text-left">
                      <template v-if="product.supplier">
                        {{ product.supplier }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <th class="table-active text-left">{{ $t('備考') }}</th>
                    <td class="text-left" colspan="3">
                      <template v-if="product.note">
                        {{ product.note }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <p class="inner mb-2" style="color:red" v-if="!isMyoridge">{{$t('下記の構成部品表内ではドラッグで移動させることが可能です。')}}</p>
        <div class="inner drag-wrap" v-if="!load">
          <div class="constitution">
            <ul class="constitution__wrap m-0 pt-4 pb-2">
              <li>
                <p class="constitution__text">
                  {{$t('品番')}}:&nbsp;{{ structures.productCode }}
                  <template v-if="structures.productVersion">
                    /&nbsp;{{ structures.productVersion }}
                  </template>
                  <br>
                  {{$t('品名')}}:&nbsp;{{ structures.productName }}<br>
                  {{ $t('数量') }}:&nbsp;1
                  <button
                    type="button"
                    class="btn btn-light create-btn ml-2"
                    @click="detailProduct({productId: structures.productId})"
                  >{{ $t('製品詳細') }}</button>
                  <button
                    type="button"
                    class="btn btn-success create-btn ml-2"
                    @click="registerModalOpen({id: 0})"
                  >{{ $t('配下に製品を追加') }}</button>
                </p>
                <draggable
                :structures="structures.structures"
                @removeStructure="removeStructure($event)"
                @addStructure="registerModalOpen($event)"
                @detailProduct="detailProduct($event)"
                @register="register()"
                ></draggable>
              </li>
            </ul>
          </div>
        </div>
      </div>
    <create-modal
    ref="register"
    :productId="structures.productId"
    @registed="addStructure($event)"
    ></create-modal>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'
import createModal from './createModal'
import Draggable from './draggable'
let level = 0
export default {
  data() {
    return {
      load: false,
      json: [],
      structures: {},
      product: {},
      productId: null,
      addId: 0,
      pageTitle: '構成部品表',
    }
  },
  components: {
    Draggable,
    createModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true
    this.productId = this.getProductIdFromQueryParameters()
    await this.$store.dispatch('auth/user')
    this.products = await this.getProducts()
    this.product = await this.getProduct(this.productId)
    await this.getStructures()
    this.load = false
  },
  methods: {
    getProductIdFromQueryParameters() {
      const url = location.search
      const searchParams = new URLSearchParams(url)
      if (searchParams.get('productId')) {
        return Number(searchParams.get('productId'))
      } else {
        this.$toasted.error(`${this.$t('製品を指定してください')}`)
        window.history.back()
        return null
      }
    },
    async getStructures() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/product/structures`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { productId: this.productId },
          }
        )
        this.structures = res.data
        await this.addKeyLevel(this.structures.structures)
        level = 0
        this.structures.productId = Number(this.structures.productId)
      } catch (error) {
        this.$toasted.show(`${this.$t('データ取得エラーメッセージ')}`)
      }
    },
    async getProducts() {
      /** DBマスタデータを取得する。 */
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/products`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
        },
      )
      if (res === null || res.status !== 200) {
        return []
      }
      return res.data
    },
    async getProduct(productId) {
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/product`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          params: {
            id: productId,
          },
        },
      )
      if (res === null || res.status !== 200) {
        return {}
      }
      return res.data
    },
    // 構成部品のarrayに同じidなどがいるため区別のためにlevelというパラメーターをもたせる
    async addKeyLevel(array) {
      for (let item of array) {
        level++
        if (!this.mixinIdKeyDisplay('products', item.productId, 'code') ||
            this.mixinIdKeyDisplay('products', item.productId, 'code') === '') {
          const prod = await this.getProduct(item.productId)
          this.products.push(prod)
        }
        this.$set(item, 'level', level)
        if (item.structures.length !== 0)
          await this.addKeyLevel(item.structures)
      }
    },
    registerModalOpen(item = {}) {
      const ids = []
      this.addId = item.id
      let breakFlag = false
      function arrayMap(array) {
        for (let i = 0; i < array.length; i++) {
          if (breakFlag) break
          ids.push(array[i].productId)
          if (array[i].level === item.level) {
            breakFlag = true
            break
          }
          if (array[i].structures.length !== 0) arrayMap(array[i].structures)
          if (!breakFlag) ids.pop()
        }
      }
      arrayMap(this.structures.structures)
      this.$refs.register.modalOpen(ids)
    },
    detailProduct(item) {
      let params = {}
      params.id = item.productId
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base/product/detail.html?${this.mixinGetUrlParams(params)}` : `/product/detail.html?${this.mixinGetUrlParams(params)}`
    },
    async removeStructure(item) {
      try {
        await this.$axios.delete(
          `${this.$appConfig.CommonApiUrl}/product/structure`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {id: item.id},
          }
        )
        this.$toasted.success(`${this.$t('構成部品を削除しました。')}`)
      } catch (error) {
        this.$toasted.show(`${this.$t('データ削除エラーメッセージ')}`)
      }
      await this.getStructures()
    },
    addStructure(item) {
      if (this.addId === 0) {
        this.structures.structures.push(item)
      } else {
        const arrayMap = (array) => {
          array.map(structure => {
            if (structure.id === this.addId) {
              structure.structures.push(item)
            }
            if (structure.structures.length !== 0) arrayMap(structure.structures)
          })
        }
        arrayMap(this.structures.structures)
      }
      this.addId = 0
      this.register()
    },
    async register() {
      const arrayMap = (array) => {
        array.map(structure => {
          for (let key of Object.keys(structure)) {
            if (structure[key] == null) {
              structure[key] = -1
            }
            if (key === 'level') {
              this.$delete(structure, key)
            }
          }
          if (!structure.structures) return
          if (structure.structures.length !== 0) arrayMap(structure.structures)
        })
      }
      arrayMap(this.structures.structures)
      try {
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/product/structure`,
          this.structures,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        await this.getStructures()
      } catch (error) {
        this.$toasted.show(`${this.$t('データ登録エラーメッセージ')}`)
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      isMyoridge: 'auth/isMyoridge',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss">
.drag-wrap {
  border-radius: 4px;
  border: 1px solid #dfdfdf;
  min-height: 10rem;
}
.constitution {
  .btn {
    font-size: 1rem !important;
    padding: .7rem .5rem !important;
    height: auto !important;
  }
}
.constitution__text {
  font-size: 1.8rem;
}
.constitution ul li ul {
  margin-top: .75em;
  margin-bottom: .75em;
  margin-left: 48px;
}

.constitution ul li ul li {
  margin-bottom: .25em;
  position: relative;
}

.constitution ul li ul li::before {
  content: "";
  position: absolute;
  top: -0.5em;
  left: -16px;
  width: 10px;
  // height: calc(100% + .75em);
  height: calc(100% + 4rem);
  border-left: 1px solid #333;
}

.constitution ul li ul li:last-child::before {
  // height: calc(1em + .25em);
  height: calc(1em + 1.3rem);
}

.constitution ul li ul li::after {
  content: "";
  position: absolute;
  // top: .75em;
  top: 2rem;
  left: -16px;
  width: 10px;
  border-bottom: 1px solid #333;
}
</style>
